import React, { useState, useEffect } from "react";
import { Typography, Button, Box } from "@mui/material";
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import RefreshIcon from '@mui/icons-material/Refresh';
import NumberFormat from "react-number-format";
import { obtenerPresupuestosCPMes } from "../../actions/PresupuestosAction";
import moment from "moment";

export default function CerradosPerdidosMes() {
  const [presupuestosTotal, setPresupuestosTotal] = useState([]);
  
  const actualizarTotales = () => {
    const desde = moment().startOf("month").format();
    const hasta = moment().endOf("month").format();
    obtenerPresupuestosCPMes(desde, hasta).then((response) => {
      setPresupuestosTotal(response.data);
    });
  };

  useEffect(() => {
    actualizarTotales();
  }, []);
  
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 0.5 }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1.5,
        mb: 2 
      }}>
        <Box sx={{
          width: 48,
          height: 48,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #ef5350 0%, #e53935 100%)',
          boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)'
        }}>
          <TrendingDownIcon sx={{ color: 'white', fontSize: 28 }} />
        </Box>
        <Box>
          <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', fontSize: '0.7rem' }}>
            GENERAL
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, fontSize: '0.95rem', lineHeight: 1.2 }}>
            Perdidos del Mes
          </Typography>
        </Box>
      </Box>

      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', mb: 2 }}>
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 800, 
            color: 'error.main',
            textAlign: 'left',
            fontSize: { xs: '1.75rem', sm: '2rem' }
          }}
        >
          <NumberFormat
            value={presupuestosTotal.total}
            displayType="text"
            thousandSeparator="."
            decimalSeparator=","
            prefix="₲ "
          />
        </Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Total presupuestos no concretados
        </Typography>
      </Box>

      <Button 
        variant="outlined" 
        color="error"
        onClick={actualizarTotales}
        startIcon={<RefreshIcon />}
        size="small"
        sx={{ 
          borderRadius: 1.5,
          textTransform: 'none',
          fontWeight: 600,
          borderWidth: 2,
          '&:hover': {
            borderWidth: 2,
            backgroundColor: 'error.light',
            color: 'white'
          }
        }}
      >
        Actualizar
      </Button>
    </Box>
  );
}
